import postDetail from "./postDetail";
export default postDetail;